import Vue from "vue"

export const UploaderEventBus = new Vue()
export const PicUploaderEventBus = new Vue()
